import { render } from "./ShowProductPlayer.vue?vue&type=template&id=424d5c0a"
import script from "./ShowProductPlayer.vue?vue&type=script&lang=js"
export * from "./ShowProductPlayer.vue?vue&type=script&lang=js"

import "./ShowProductPlayer.vue?vue&type=style&index=0&id=424d5c0a&lang=css"

import exportComponent from "D:\\VueJs project\\product\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__